import { Link } from "react-router-dom";
import Navbar from "@/components/marketing/Navbar.jsx";
import Footer from "@/components/marketing/Footer.jsx";
import { Mic, Wand2, Send } from "lucide-react";

export default function HowItWorks() {
  const steps = [
    { icon: Mic, n: "01", t: "Tap the mic", d: "Pick your language, your output mode, then press record. Speak naturally — switch languages mid-sentence." },
    { icon: Wand2, n: "02", t: "AI polishes instantly", d: "We transcribe (OpenAI Whisper) and then polish with GPT into your chosen output format." },
    { icon: Send, n: "03", t: "Ship it", d: "Copy, edit, transform further or save to history. Your snippets and dictionary keep you fast." },
  ];
  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <section className="pt-16 pb-12 text-center bg-mesh">
        <div className="text-xs uppercase tracking-widest font-semibold text-brand-purple">How it works</div>
        <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-brand-navy">Three taps.<br />A polished draft.</h1>
      </section>
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-5 lg:px-8 grid md:grid-cols-3 gap-5">
          {steps.map((s) => (
            <div key={s.n} className="bg-white rounded-3xl border border-brand-borderc p-7 hover:shadow-soft transition">
              <div className="text-gradient-primary text-4xl font-bold leading-none">{s.n}</div>
              <div className="mt-5 w-11 h-11 rounded-xl bg-brand-surface flex items-center justify-center text-brand-purple"><s.icon className="w-5 h-5" /></div>
              <h3 className="mt-4 text-lg font-semibold text-brand-navy">{s.t}</h3>
              <p className="mt-1.5 text-sm text-brand-muted leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <Link to="/signup" className="btn-primary-gradient rounded-full px-7 py-3.5 font-semibold inline-flex">Try it free →</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
